import React, { useState } from "react";

import PricingData from "~/data/sidebar/pricing_bandwidth.json"
import PartialCTA from '../partials/cta'

const PricingBandwidth = ({ block }) => {

  const allRegions = {}
  const defaultRegionValue = 3

  PricingData.regions.forEach((region, index) => {
    allRegions[index] = defaultRegionValue
  });

  const [active, setActive] = useState(0);
  const [rangeValue, setRangeValue] = useState(allRegions)

  const toggleTabs = e => {
    const index = parseInt(e.target.id, 0);

    if (index !== active) {
      setActive(index);
      setRegionPrice(PricingData.regions[index]?.pricing[rangeValue[index]]?.price)
    }
  };

  const defaultValue = PricingData.regions[0].pricing[defaultRegionValue].price
  const [regionPrice, setRegionPrice] = useState(defaultValue);

  function getValues(event) {
    let region = event.target.id.split('-')[1]
    let value = event.target.value

    setRangeValue({ ...rangeValue, [region]: value })
    setRegionPrice(PricingData.regions[region].pricing[value].price)
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name ? block.css_class_name : ''}`}>
      <div className='container'>
        <ul className="tabs-header">
          {PricingData.regions.map((region, index) => {
            return <li key={index} className={`${active === index ? "is-active" : ""}`} onClick={toggleTabs} active={`${active === index}`} id={index}>
              {region.name && ( region.name )}
            </li>
          })}
        </ul>
        <div className="tabs-wr">
          {PricingData.regions.map((region, index) => {

            let sliderMax = region.pricing.length - 1

            let bandwidthPoints = region.pricing.map((price, index) => {
              return <li key={index}>
                <span>{price.value}</span>
              </li>
            })

            return <div key={index} className={`tab-content ${active === index ? "is-active" : ""}`} active={`${active === index}`}>
              <div className="left">
                {region.image && (
                  <img src={region.image} alt={region.image_alt_text} title={region.image_alt_text} />
                )}
              </div>
              <div className="right">
                <div className="label">Estimated price</div>
                <div className="price">{regionPrice}<span> /month</span></div>
                
                <div className="slidecontainer">
                  <input id={`range-${index}`} type="range" defaultValue="3" className="slider" min="0" max={sliderMax} onChange={(event) => getValues(event)} />
                  <ul className="bandwidth-points">
                    {bandwidthPoints}
                  </ul>
                </div>

                {block.cta_field && ( <PartialCTA data={block.cta_field} /> )}
              </div>
            </div>
          })}
        </div>
      </div>
    </section>
  )
}

export default PricingBandwidth
